"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useChangeQuantity = void 0;
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _updateOfferItem = require("../../../api/updateOfferItem");
// istanbul ignore file -- api
/**
 * Hook for getting `onChangeQuantity` handler function.
 * Also return `loadingQuantityChange` flag to indicate if quantity change is in progress.
 * `loadingQuantityChange` is set to false when shopping context is loaded.
 */ const useChangeQuantity = (param)=>{
    let { offerId, revalidateSelectedOfferItems } = param;
    const logger = (0, _logger.useLogger)('useChangeQuantity');
    const { isLoading: isLoadingShoppingContext } = (0, _shoppingContext.useShoppingContext)();
    const [loadingQuantityChange, setLoadingQuantityChange] = (0, _react.useState)(false);
    const [revalidating, setRevalidating] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (loadingQuantityChange && !isLoadingShoppingContext && !revalidating) {
            setLoadingQuantityChange(false);
        }
    }, [
        loadingQuantityChange,
        isLoadingShoppingContext,
        revalidating
    ]);
    const onChangeQuantity = (0, _react.useCallback)((param)=>{
        let { itemCode, localName, quantity, formattedPrice, position } = param;
        setLoadingQuantityChange(true);
        (0, _updateOfferItem.updateOfferItem)({
            choiceId: offerId,
            itemCode,
            localName,
            quantity,
            formattedPrice,
            position
        }).then(async ()=>{
            setRevalidating(true);
            await revalidateSelectedOfferItems();
            setRevalidating(false);
        }).catch((error)=>{
            logger.error(new Error('Failed to update offer item quantity', {
                cause: error
            }));
        });
    }, [
        logger,
        offerId,
        revalidateSelectedOfferItems
    ]);
    return (0, _react.useMemo)(()=>({
            loadingQuantityChange,
            onChangeQuantity
        }), [
        loadingQuantityChange,
        onChangeQuantity
    ]);
};
exports.useChangeQuantity = useChangeQuantity;
